<template>
  <div class="auth-card">
    <div class="auth-card__header">
      <slot name="header" />
      <h6 v-if="title" class="auth-card__title">
        {{ title }}
      </h6>
      <div v-if="!!subtitle" class="auth-card__subtitle">
        {{ subtitle }}
      </div>
      <div v-if="errorMessage" class="auth-card__error">{{ errorMessage }}</div>
    </div>
    <slot />

    <slot name="after-form" />
  </div>
</template>

<script lang="ts" setup>
type AuthCardProps = {
  title?: string
  subtitle?: string
  errorMessage?: string
}
defineProps<AuthCardProps>()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/media' as media;
@use '@/assets/styles/colors' as colors;

.auth-card {
  display: flex;
  flex-direction: column;
  gap: 32px;

  width: 480px;
  padding: 40px;

  border-radius: 12px;
  border: 1px solid colors.$gray-10;
  box-shadow: 0 0 18px 8px #27313f05;

  &__header {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__title {
    margin-block-start: 0;
    margin-block-end: 2.33em;
    font-size: 18px;
    font-weight: 600;
  }

  &__subtitle {
    font-size: 13px;
    color: colors.$gray-80;
    line-height: 20px;
  }

  &__error {
    color: colors.$error-50;
    font-weight: 600;
  }

  @include media.max(media.$laptop) {
    padding: 32px;
    width: 392px;
  }

  @include media.max(media.$tablet) {
    padding: 0;
    border: none;
    box-shadow: none;
    width: 100%;
    max-width: 350px;
  }

  @include media.max(media.$mobile) {
    width: 100%;
    height: 100%;
  }
}
</style>
